import { Component, forwardRef, Injector } from '@angular/core';
import { IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-colorpicker',
  templateUrl: './r-colorpicker.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RColorpickerComponent),
      multi: true
    }
  ]
})
export class RColorpickerComponent extends RenderComponentBase {
  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {}
  static KEY = 'r-d-colorpicker';
}
